import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { targetEnv } from '@fs/zion-config'

const useCensusPermission = () => {
  const [hasCensusPermission, setHasCensusPermission] = useState(false)
  const { i18n } = useTranslation()

  useEffect(() => {
    if (i18n.language === 'en' || targetEnv === 'local') {
      setHasCensusPermission(true)
    }
  }, [i18n.language])

  const login = () => {
    window.location.replace(`/auth/familysearch/login?returnUrl=${encodeURIComponent(window.location)}`)
  }

  return { hasCensusPermission, login }
}

export default useCensusPermission
